<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M11.0388 5.1011C11.2102 4.69198 11.7898 4.69198 11.9612 5.1011L13.6409 9.11164C13.713 9.28375 13.875 9.4014 14.0609 9.41678L18.3943 9.775C18.8363 9.81155 19.0154 10.3628 18.6793 10.6522L15.3841 13.4891C15.2427 13.6108 15.1808 13.8012 15.2237 13.9828L16.2221 18.2148C16.3239 18.6465 15.855 18.9872 15.4759 18.7569L11.7596 16.4997C11.6001 16.4028 11.3999 16.4028 11.2404 16.4997L7.52414 18.7569C7.14504 18.9872 6.67609 18.6465 6.77793 18.2148L7.77631 13.9828C7.81915 13.8012 7.7573 13.6108 7.61589 13.4891L4.32071 10.6522C3.98457 10.3628 4.16369 9.81155 4.60574 9.775L8.93906 9.41678C9.12503 9.4014 9.28696 9.28375 9.35905 9.11164L11.0388 5.1011Z" :fill="color" />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  color: { type: String, default: '#F3CD02' }
})
</script>
